export default "__VITE_ASSET__Dw0wvxh0__"